class ProductCard extends HTMLElement {
  #anchors = this.querySelectorAll('a');
  #gaItemListName = this.closest('[data-ga-item-list-name]').dataset.gaItemListName;
  #productJson = JSON.parse(this.querySelector('[data-product-json]').textContent);

  connectedCallback() {
    this.#anchors.forEach((anchor) => anchor.addEventListener('click', () => this.onAnchorClick()));
    this.sendAnalytics();
  }

  /**
   * Set the item list name in session storage when the anchor is clicked
   * This is used to track the item list name for GA4 events
   */
  onAnchorClick() {
    sessionStorage.setItem(
      'gaProductJson',
      JSON.stringify({
        ...this.#productJson,
        itemListName: this.#gaItemListName,
      })
    );
  }

  sendAnalytics() {
    Shopify.analytics.publish('karl:product_variants', {
      productVariants: [this.#productJson],
    });
  }
}

customElements.define('product-card', ProductCard);
